<m-expansion-panel *ngIf="listaPositivoConsorcio.length > 0" [id]="'hisCredito-consorcio'" [title]="'Consórcio'" [active]="larguraEhSuperiorMin">
  <div *ngIf="!listaServicoFalha.includes('info-positivo')" id="id-table-consorcio">
    <div *ngFor="let operacao of listaPositivoConsorcio; index as i">

      <div class="row">

        <div class="col-md-4 my-3">
          <div class="row">
            <div class="col-md-12" id="hisCredito-consorcio-nome-empresa-{{i}}">
              <label class="row etiqueta">Empresa</label>
              <span id=" row id-span-consorcio-empresa">{{operacao.empresa | naoinformado}} </span>
            </div>

          </div>

          <div class="row my-3">
            <div class="col-md-12" id="hisCredito-consorcio-nome-empresa-{{i}}">
              <label class="row etiqueta">Contrato</label>
              <span class="row" id="id-span-consorcio-numeroContrato">{{operacao.numeroContrato |
                naoinformado}}</span>
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-6" id="hisCredito-consorcio-num-agencia-{{i}}">
              <label class="row etiqueta">Agência</label>
              <span class="row" id="id-span-consorcio-agencia">{{operacao.agencia | naoinformado}} </span>
            </div>

            <div class="col-md-6" id="hisCredito-consorcio-cota-{{i}}">
              <label class="row etiqueta">Cota</label>
              <span class="row" id="id-span-consorcio-cota">{{operacao.cota | naoinformado}} </span>
            </div>

          </div>

          <div class="row my-3">


            <div class="col-md-6" id="hisCredito-consorcio-sequencia-{{i}}">
              <label class="row etiqueta">Sequência</label>
              <span class="row" id="id-span-consorcio-sequencia">{{operacao.sequencia | naoinformado}} </span>
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-6" id="hisCredito-consorcio-situacao-cota-{{i}}">
              <label class="row etiqueta">Situação da cota</label>
              <span class="row" id="id-span-consorcio-situacaoCota">{{operacao.situacaoCota | naoinformado}} </span>
            </div>

            <div class="col-md-6" id="hisCredito-consorcio-saldo-devedor-total-{{i}}">
              <label class="row etiqueta">Saldo devedor total</label>
              <span class="row" id="id-span-consorcio-saldoDevedorTotal">{{operacao.saldoDevedorTotal | moedaReal}}
              </span>
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-6" id="hisCredito-consorcio-valor-parcela-{{i}}">
              <label class="row etiqueta">Total de parcelas</label>
              <span class="row" id="id-span-consorcio-totalParcelas">{{operacao.totalParcelas | naoinformado}} </span>
            </div>

            <div class="col-md-6" id="hisCredito-consorcio-ultima-atualizacao-{{i}}">
              <label class="row etiqueta">Última atualização</label>
              <span class="row" id="id-span-consorcio-ultimaAtualizacao">{{operacao.ultimaAtualizacao | naoinformado}}
              </span>
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-6" id="hisCredito-consorcio-inicio-contrato-{{i}}">
              <label class="row etiqueta">Início do contrato</label>
              <span class="row" id="id-span-consorcio-inicioContrato">{{operacao.inicioContrato |
                naoinformado}}</span>
            </div>

            <div class="col-md-6" id="hisCredito-consorcio-valor-contratado-{{i}}">
              <label class="row etiqueta">Valor contratado</label>
              <span class="row" id="id-span-consorcio-temValorContratado">{{operacao.temValorContratado |
                moedaReal}}</span>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="row">

            <div class="col-md-4" id="hisCredito-consorcio-num-cnpj-{{i}}">
              <label class="etiqueta">CNPJ</label>
              <span class="row" id="id-span-consorcio-cnpj">{{operacao.cnpj | naoinformado}} </span>
            </div>

            <div class="col-md-4" id="hisCredito-consorcio-num-operacao-{{i}}">
              <label class="row etiqueta">Número da operação</label>
              <span class="row" id="id-span-consorcio-numeroOperacao">{{operacao.numeroOperacao |
                naoinformado}}</span>
            </div>

            <div class="col-md-4" id="hisCredito-consorcio-data-contemplacao-{{i}}">
              <label class="row etiqueta">Data da contemplação</label>
              <span class="row" id="id-span-consorcio-terminoPrevisto">{{operacao.terminoPrevisto | naoinformado}}
              </span>
            </div>


          </div>

          <div class="row">
            <div class="table-responsive" id="div-table-consorcio-detalhe">
              <table id="id-table-consorcio-detalhe" class="table table-striped table-borderless" aria-label="Tabela de consorcio">
                <thead>
                  <tr>
                    <th scope="col">Data do vencimento</th>
                    <th scope="col">Valor do débito</th>
                    <th scope="col">Data do pagamento</th>
                    <th scope="col">Valor do pagamento</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let detalhe of operacao.detalhe12Meses; index as i">
                    <td>{{ detalhe.dataVencimento | naoinformado }}</td>
                    <td>{{ detalhe.valorParcela | moedaReal }}</td>
                    <td>{{ detalhe.dataPagamento | naoinformado }}</td>
                    <td>{{ detalhe.valorPagamento | moedaReal}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <hr *ngIf="listaPositivoConsorcio.length > 1">
    </div>
  </div>
</m-expansion-panel>

<m-expansion-panel *ngIf="listaPositivoCartaoCredito.length > 0"  [id]="'hisCredito-cartaoCredito'" [title]="'Cartão de crédito'" [active]="larguraEhSuperiorMin">
  <div *ngIf="!listaServicoFalha.includes('info-positivo')" id="id-table-cartaoCredito">
    <div *ngFor="let operacao of listaPositivoCartaoCredito; index as i">

      <div class="row">
        <div class="col-md-4 my-3">
          <div class="row">
            <div class="col-md-12" id="cartaoCredito-nume-empresa-{{i}}">
              <label class="row etiqueta">Empresa</label>
              <span class="row" id="id-span-cartaoCredito-empresa">{{operacao.empresa | naoinformado}} </span>
            </div>
          </div>

          <div class="row my-3">

            <div class="col-md-12" id="cartaoCredito-num-cartao-{{i}}">
              <label class="row etiqueta">Número do cartão</label>
              <span class="row" id="id-span-cartaoCredito-numeroCartao">{{operacao.ultimosNumerosCartao |
                naoinformado}} </span>
            </div>


          </div>


          <div class="row my-3">
            <div class="col-md-6" id="cartaoCredito-inicio-contrato-{{i}}">
              <label class="row etiqueta">Início do contrato</label>
              <span class="row" id="id-span-cartaoCredito-inicioContrato">{{operacao.inicioContrato | naoinformado}}
              </span>
            </div>
            <div class="col-md-6" id="cartaoCredito-num-agencia-{{i}}">
              <label class="row etiqueta">Agência</label>
              <span class="row" id="id-span-cartaoCredito-agencia">{{operacao.agencia | naoinformado}} </span>
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-6" id="cartaoCredito-saldo-prox-fatura-{{i}}">
              <label class="row etiqueta">Saldo da próxima fatura</label>
              <span class="row" id="id-span-cartaoCredito-saldoProxFatura">{{operacao.saldoProxFatura | moedaReal}}
              </span>
            </div>

            <div class="col-md-6" id="cartaoCredito-ultima-atualizacao-{{i}}">
              <label class="row etiqueta">Última atualização</label>
              <span class="row" id="id-span-cartaoCredito-ultimaAtualizacao">{{operacao.ultimaAtualizacao |
                naoinformado}} </span>
            </div>
          </div>


        </div>
        <div class="col-md-8">
          <div class="row my-3">
            <div class="col-md-4" id="cartaoCredito-num-cnpj-{{i}}">
              <label class="row etiqueta">CNPJ</label>
              <span class="row" id="id-span-cartaoCredito-cnpj">{{operacao.cnpj | naoinformado}} </span>
            </div>

            <div class="col-md-4" id="cartaoCredito-num-operacao-{{i}}">
              <label class="row etiqueta">Número da operação</label>
              <span class="row" id="id-span-cartaoCredito-numeroOperacao">{{operacao.numeroOperacao | naoinformado}}
              </span>
            </div>


          </div>

          <div class="row my-3">
            <div class="table-responsive" id="div-table-cartaoCredito-detalhe-{{i}}">
              <table id="id-table-cartaoCredito-detalhe" class="table table-striped table-borderless" aria-label="Tabela de cartão de crédito">
                <thead>
                  <tr>
                    <th scope="col">Data do vencimento</th>
                    <th scope="col">Valor do débito</th>
                    <th scope="col">Data do pagamento</th>
                    <th scope="col">Valor do pagamento</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let detalhe of operacao.detalhe12Meses; index as i">
                    <td>{{ detalhe.dataVencimento | naoinformado }}</td>
                    <td>{{ detalhe.valorParcela | moedaReal }}</td>
                    <td>{{ detalhe.dataPagamento | naoinformado }}</td>
                    <td>{{ detalhe.valorPagamento | moedaReal}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <hr *ngIf="listaPositivoCartaoCredito.length > 1">
    </div>
  </div>
</m-expansion-panel>

<m-expansion-panel *ngIf="listaPositivoRotativo.length > 0" [id]="'hisCredito-rotativo'" [title]="'Rotativo'" [active]="larguraEhSuperiorMin">
  <div *ngIf="!listaServicoFalha.includes('info-positivo')" id="id-table-rotativo">
    <div *ngFor="let operacao of listaPositivoRotativo; index as i">

      <div class="row">
        <div class="col-md-4 my-3">

          <div class="row">
            <div class="col-md-12" id='hisCredito-rotativo-nome-empresa-{{i}}'>
              <label class="row etiqueta">Empresa</label>
              <span class="row" id="id-span-rotativo-empresa">{{operacao.empresa | naoinformado}} </span>
            </div>
          </div>

          <div class="row my-3">

            <div class="col-md-12" id='hisCredito-rotativo-contrato-{{i}}'>
              <label class="row etiqueta">Contrato</label>
              <span class="row" id="id-span-rotativo-contrato">{{operacao.numeroContrato | naoinformado}} </span>
            </div>

          </div>


          <div class="row my-3">
            <div class="col-md-12" id='hisCredito-rotativo-num-operacao-{{i}}'>
              <label class="row etiqueta">Número da operação</label>
              <span class="row" id="id-span-rotativo-numeroOperacao">{{operacao.numeroOperacao | naoinformado}}
              </span>
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-12" id='hisCredito-rotativo-num-agencia-{{i}}'>
              <label class="row etiqueta">Agência</label>
              <span class="row" id="id-span-rotativo-agencia">{{operacao.agencia | naoinformado}} </span>
            </div>
          </div>

        </div>
        <div class="col-md-8 my-3">
          <div class="row">
            <div class="col-md-4" id='hisCredito-rotativo-num-cnpj-{{i}}'>
              <label class="row etiqueta">CNPJ</label>
              <span class="row" id="id-span-rotativo-cnpj">{{operacao.cnpj | naoinformado}} </span>
            </div>

            <div class="col-md-4" id='hisCredito-rotativo-inicio-contrato-{{i}}'>
              <label class="row etiqueta">Início do contrato</label>
              <span class="row" id="id-span-rotativo-inicioContrato">{{operacao.inicioContrato | naoinformado}}
              </span>
            </div>

            <div class="col-md-4" id='hisCredito-rotativo-ultima-atualizacao-{{i}}'>
              <label class="row etiqueta">Última atualização</label>
              <span class="row" id="id-span-rotativo-ultimaAtualizacao">{{operacao.ultimaAtualizacao | naoinformado}}
              </span>
            </div>

          </div>
          <div class="row my-3">
            <div class="table-responsive" id="div-table-rotativo-detalhe">
              <table id="id-table-rotativo-detalhe" class="table table-striped table-borderless">
                <thead>
                  <tr>
                    <th scope="col">Data do vencimento</th>
                    <th scope="col">Valor utilizado</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let detalhe of operacao.detalhe12Meses; index as i">
                    <td>{{ detalhe.dataVencimento | naoinformado }}</td>
                    <td>{{ detalhe.saldoUtilizado | moedaReal }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

      <hr *ngIf="listaPositivoRotativo.length > 1">
    </div>
  </div>
</m-expansion-panel>

<m-expansion-panel *ngIf="listaPositivoParcelado.length > 0" [id]="'hisCredito-parcelado'" [title]="'Parcelado'" [active]="larguraEhSuperiorMin">
  <div *ngIf="!listaServicoFalha.includes('info-positivo')" id="id-table-parcelado">
    <div *ngFor="let operacao of listaPositivoParcelado; index as i">
      <div class="row">
        <div class="col-md-4 my-3">
          <div class="row">
            <div class="col-md-12" id="hisCredito-parcelado-nome-empresa-{{i}}">
              <label class="row etiqueta">Empresa</label>
              <span class="row" id="id-span-parcelado-empresa">{{operacao.empresa | naoinformado}} </span>
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-6" id="hisCredito-parcelado-num-contrato-{{i}}">
              <label class="row etiqueta">Contrato</label>
              <span class="row" id="id-span-parcelado-contrato">{{operacao.numeroContrato | naoinformado}} </span>
            </div>

          </div>

          <div class="row my-3">

            <div class="col-md-12" id="hisCredito-parcelado-num-operacao-{{i}}">
              <label class="row etiqueta">Número da operação</label>
              <span class="row" id="id-span-parcelado-numeroOperacao">{{operacao.numeroOperacao | naoinformado}}
              </span>
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-6" id="hisCredito-parcelado-num-agencia-{{i}}">
              <label class="row etiqueta">Agência</label>
              <span class="row" id="id-span-parcelado-agencia">{{operacao.agencia | naoinformado}} </span>
            </div>

            <div class="col-md-6" id="hisCredito-parcelado-valor-total-{{i}}">
              <label class="row etiqueta">Valor Total</label>
              <span class="row" id="id-span-parcelado-valorTotalContrato">{{operacao.valorTotalContrato | moedaReal}}
              </span>
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-6" id="hisCredito-parcelado-total-parcelas-{{i}}">
              <label class="row etiqueta">Total de parcelas</label>
              <span class="row" id="id-span-parcelado-totalParcelas">{{operacao.totalParcelas | naoinformado}} </span>
            </div>
            <div class="col-md-6" id="hisCredito-parcelado-parcelas-vencer-{{i}}">
              <label class="row etiqueta">Parcelas a vencer</label>
              <span class="row" id="id-span-parcelado-parcelasAVencer">{{operacao.parcelasAVencer | naoinformado}}
              </span>
            </div>
          </div>

          <div class="row my-3">

            <div class="col-md-6" id="hisCredito-parcelado-valor-proxima-parcela-{{i}}">
              <label class="row etiqueta">Valor próxima parcela</label>
              <span class="row" id="id-span-parcelado-valorProximaParcela">{{operacao.valorProximaParcela |
                moedaReal}} </span>
            </div>
            <div class="col-md-6" id="hisCredito-parcelado-ultima-atualizacao-{{i}}">
              <label class="row etiqueta">Última atualização</label>
              <span class="row" id="id-span-parcelado-ultimaAtualizacao">{{operacao.ultimaAtualizacao | naoinformado}}
              </span>
            </div>
          </div>

        </div>

        <div class="col-md-8 my-3">

          <div class="row my-4">
            <div class="col-md-3" id="hisCredito-parcelado-num-cnpj-{{i}}">
              <label class="row etiqueta">CNPJ</label>
              <span class="row" id="id-span-parcelado-cnpj">{{operacao.cnpj | naoinformado}} </span>
            </div>

            <div class="col-md-4" id="hisCredito-parcelado-inicio-contrato-{{i}}">
              <label class="row etiqueta">Início do contrato</label>
              <span class="row" id="id-span-parcelado-inicioContrato">{{operacao.inicioContrato | naoinformado}}
              </span>
            </div>

            <div class="col-md-4" id="hisCredito-parcelado-termino-previsto-{{i}}">
              <label class="row etiqueta">Término previsto</label>
              <span class="row" id="id-span-parcelado-terminoPrevisto">{{operacao.terminoPrevisto | naoinformado}}
              </span>
            </div>
          </div>

          <div class="table-responsive" id="div-table-parcelado-detalhe-{{i}}">
            <table id="id-table-parcelado-detalhe" class="table table-striped table-borderless" aria-label="Tabela de parcelado">
              <thead>
                <tr>
                  <th scope="col">Data do vencimento</th>
                  <th scope="col">Valor do débito</th>
                  <th scope="col">Data do pagamento</th>
                  <th scope="col">Valor do pagamento</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let detalhe of operacao.detalhe12Meses; index as i">
                  <td>{{ detalhe.dataVencimento | naoinformado }}</td>
                  <td>{{ detalhe.valorParcela | moedaReal }}</td>
                  <td>{{ detalhe.dataPagamento | naoinformado }}</td>
                  <td>{{ detalhe.valorPagamento | moedaReal}}</td>
                </tr>
              </tbody>
            </table>
          </div>



        </div>
      </div>

      <hr *ngIf="listaPositivoParcelado.length > 1">
    </div>
  </div>
</m-expansion-panel>

<m-expansion-panel *ngIf="listaPositivoConsumo.length > 0"  [id]="'hisCredito-consumo'" [title]="'Consumo'" [active]="larguraEhSuperiorMin">
  <div *ngIf="!listaServicoFalha.includes('info-positivo')" id="id-table-consumo">
    <div *ngFor="let operacao of listaPositivoConsumo; index as i">

      <div class="row">
        <div class="col-md-4">

          <div class="row my-3">
            <div class="col-md-12" id='hisCredito-rotativo-nome-empresa-{{i}}'>
              <label class="row etiqueta">Empresa</label>
              <span class="row" id="id-span-consumo-empresa">{{operacao.empresa | naoinformado}} </span>
            </div>
          </div>

          <div class="row my-3">

            <div class="col-md-12 truncate text-wrap" id="hisCredito-consumo-num-contrato-{{i}}">
              <label class="row  etiqueta">Contrato</label>
              <span class="row truncate text-break" id="id-span-consumo-contrato">{{operacao.numeroContrato | naoinformado}} </span>
            </div>


          </div>

          <div class="row my-3">

            <div class="col-md-6" id="hisCredito-consumo-inicio-contrato-{{i}}">
              <label class="row etiqueta">Início do contrato</label>
              <span class="row" id="id-span-consumo-inicio-contrato">{{operacao.inicioContrato | naoinformado}}
              </span>
            </div>

            <div class="col-md-6" id="hisCredito-consumo-valor-ultima-parcela-{{i}}">
              <label class="row etiqueta">Valor da última parcela</label>
              <span class="row" id="id-span-consumo-valor-da-ultima-parcela">{{operacao.valorUltimaParcela |
                moedaReal}} </span>
            </div>
          </div>



        </div>
        <div class="col-md-8">
          <div class="row my-3">
            <div class="col-md-6" id="hisCredito-consumo-num-cnpj-{{i}}">
              <label class="row etiqueta">CNPJ</label>
              <span class="row" id="id-span-consumo-cnpj">{{operacao.cnpj | naoinformado}} </span>
            </div>

            <div class="col-md-6" id="hisCredito-consumo-ultima-atualizacao-{{i}}">
              <label class="etiqueta">Última atualização</label>
              <br />
              <span id="id-span-consumo-ultima-atualizacao">{{operacao.ultimaAtualizacao | naoinformado}} </span>
            </div>


          </div>

          <div class="row">
            <div class="table-responsive" id="div-table-consumo-detalhe-{{i}}">
              <table id="id-table-consumo-detalhe" class="table table-striped table-borderless" aria-label="Tabela de consumo">
                <thead>
                  <tr>
                    <th scope="col">Data do vencimento</th>
                    <th scope="col">Valor do débito</th>
                    <th scope="col">Data do pagamento</th>
                    <th scope="col">Valor do pagamento</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let detalhe of operacao.detalhe12Meses; index as i">
                    <td>{{ detalhe.dataVencimento | naoinformado }}</td>
                    <td>{{ detalhe.valorParcela | moedaReal }}</td>
                    <td>{{ detalhe.dataPagamento | naoinformado }}</td>
                    <td>{{ detalhe.valorPagamento | moedaReal}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <hr *ngIf="listaPositivoConsumo.length > 1">

    </div>
  </div>
</m-expansion-panel>
